import { Link } from "gatsby";
import React from "react";

export default function CertifiedProvide({
  backgroundCol,
  data,
  FirstHead,
  ColorHead,
  secondHead,
  headcol,
}) {
  return (
    <div className={`${backgroundCol ? backgroundCol : "bg-midBlue "} py-16`}>
      <div className="mainDiv text-white pt-12">
        <div className="head w-full lg:w-5/12 fle-col mx-auto justify-center text-center pb-10 max-w-6xl">
          <h2 className="text-4xl font-bold leading-relaxed font-secondary">
            {FirstHead ? FirstHead : "A"}{" "}
            <span className={`${headcol ? headcol : "text-orange"}  `}>
              {ColorHead ? ColorHead : "Global Leader "}
            </span>
            {secondHead ? secondHead : "  in Document Translation Services"}
          </h2>
          <p className=" pt-6">
            Tomedes offers certified translation services for virtually any kind
            of document for official use in most jurisdictions. The following
            are just some of the many types of translation certifications we
            provide:
          </p>
          {/* <span className="border-b w-full font-light block border-textlight"></span> */}
        </div>
        <div className="content w-full lg:w-8/12 text-white mx-auto justify-center ">
          <section className="">
            <div className="max-w-5xl mx-auto  mlap:px-6  ">
              {data
                ? data.map(
                    ({
                      FirstWhite,
                      link,
                      ColorHead,
                      lastHeadColor,
                      ThirdBlue,
                      Content,
                      bottomContent,
                      title,
                      detail,
                      borderLine,
                      listS,
                    }) => (
                      <div
                        className={`lap:grid lap:grid-cols-2 py-10 ${
                          borderLine ? "border-b border-border" : null
                        }`}
                      >
                        <div className="lap:pr-12">
                          <h3 className="text-2xl text-gray font-bold font-secondary leading-relaxed mb-4 lg:mb-0 ">
                            {FirstWhite}{" "}
                            <span className="text-orange">{ColorHead} </span>
                            {title}{" "}
                            <span className={`${lastHeadColor}`}>
                              {ThirdBlue}{" "}
                            </span>
                          </h3>
                        </div>

                        <div className="lg:pl-44 pl-4">
                          {listS ? (
                            <ul className="list-disc ">
                              <li className="hover:text-orange">
                                <a href="/birth-certificate-translation.php">
                                  Birth Certificates
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/uscis-translation-services">
                                  Immigration Documents for USCIS
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/marriage-certificate-translation.php">
                                  Marriage Certificates
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/notarized-translation.php">
                                  Notarized Documents
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/transcript-translation-services">
                                  Academic Documents
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/legal-translation.php">
                                  Legal Documents
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/medical-translation.php">
                                  Medical Documents
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/technical-translation.php">
                                  Technical Documents
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/legal-translation/sworn">
                                Sworn Translation
                                </a>
                              </li>
                              <li className="pt-6 hover:text-orange">
                                <a href="/certified-translation/apostille">
                                Apostille Translation
                                </a>
                              </li>
                            </ul>
                          ) : null}
                          <p className="text-darkMist text-base leading-8 font-opensans">
                            {Content}
                            {detail}
                          </p>
                          {bottomContent ? (
                            <p className="text-darkMist text-base mt-6 leading-8 font-opensans">
                              {bottomContent}
                            </p>
                          ) : null}

                          {link ? (
                            <div className="btn text-white max-w-max hover:text-orange pt-8">
                              <Link
                                to="/business-translation.php"
                                className="text-lg learnmore"
                              >
                                GET STARTED
                              </Link>
                              <div className="border-b bg-white"></div> {link}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )
                  )
                : null}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
